import { useMutation, useQuery } from 'react-query';
import { request, request_v2 } from '../utils/axios-utils';

const GetMergedGuidelines = async (pageNum, pageSize, searchText) => {
    const { data } = await request_v2({
        method: 'get',
        url: '/guideline/ListMergedGuidelines',
        params: {
            pageNum,
            pageSize,
            searchText,
        },
    });
    return data;
};

const CreateMergedGuideline = async (name, description, links, ExcludeLinks) => {
    const { data } = await request_v2({
        method: 'post',
        url: '/guideline/mergeLinks',
        body: {
            name,
            description,
            links,
            ExcludeLinks,
        },
    });
};

const AddBarcodeToGuideline = async (mergeId, barcode, comment) => {
    const { data } = await request_v2({
        method: 'post',
        url: '/guideline/addBarcodeToGuideline',
        body: {
            mergeId,
            barcode,
            comment,
        },
    });
    return data;
};

const AddLinkToGuideline = async (mergeId, link) => {
    const { data } = await request_v2({
        method: 'post',
        url: '/guideline/addLinkToMerge',
        body: {
            mergeId,
            link,
        },
    });
    return data;
};

const getItemCountForGuideline = async link => {
    let links = link;
    if (Array.isArray(links)) {
        links = links.filter(d => !!d);
        if (links.length == 0) {
            return { total: 0 };
        }
    } else {
        if (links == null || links == '') {
            console.log('Internal error');
            return { total: 0 };
            // throw new Error('Invalid Link');
        }
    }
    console.log('Calling API with data', { links });
    const { data } = await request_v2({
        method: 'post',
        url: '/guideline/getItemCountForGuideline',
        body: {
            link: links,
        },
    });
    return data;
};

export const useGetMergedGuidelines = (pageNum, pageSize, searchText) =>
    useQuery(['MergedLinks', pageNum, pageSize, searchText], () => GetMergedGuidelines(pageNum, pageSize, searchText));
export const useGetItemCountForGuideline = link =>
    useQuery(['getItemCountForGuideline', link], () => getItemCountForGuideline(link), {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    });
const LookupSkusForMerge = async (companyCode, identifiers) => {
    const { data } = await request_v2({
        method: 'post',
        url: '/guideline/lookupSkusForMerge',
        body: { companyCode, identifiers },
    });
    return data;
};

const CreateMergedGuidelineFromSkus = async (name, description, skuIds) => {
    const { data } = await request_v2({
        method: 'post',
        url: '/guideline/createFromSkus',
        body: { name, description, skuIds },
    });
    return data;
};

export const useCreateMergedGuidelines = () =>
    useMutation({
        mutationFn: async ([name, description, links, ExcludeLinks]) => {
            return await CreateMergedGuideline(name, description, links, ExcludeLinks);
        },
    });

export const useLookupSkusForMerge = () =>
    useMutation({
        mutationFn: async ([companyCode, identifiers]) => LookupSkusForMerge(companyCode, identifiers),
    });

export const useCreateMergedGuidelineFromSkus = () =>
    useMutation({
        mutationFn: async ([name, description, skuIds]) => CreateMergedGuidelineFromSkus(name, description, skuIds),
    });

export const useAddBarcodeToGuideline = () =>
    useMutation({
        mutationFn: async ([mergeId, barcode, comment]) => {
            return await AddBarcodeToGuideline(mergeId, barcode, comment);
        },
    });

export const useAddLinkToGuideline = () =>
    useMutation({
        mutationFn: async ([mergeId, link]) => {
            return await AddLinkToGuideline(mergeId, link);
        },
    });
export const DeleteMergeGuideline = mergeId => {
    const { data } = request_v2({
        method: 'delete',
        url: `/guideline/deleteMergeGuideline?mergeId=${mergeId}`,
    });
    return data;
};

export const useDeleteMergeGuideline = () =>
    useMutation({
        mutationFn: async ([mergeId]) => {
            return await DeleteMergeGuideline(mergeId);
        },
    });
